import { LogSummary } from '../../apis/mgmt/api';
import { DataViewProps } from '../common/DataView';


export function LogSummaryLegend(props: 
    DataViewProps<LogSummary>
) {

    const s = props.data;
    const indeterminate_saved = (s?.createdOrUpdated||0) - (s?.created||0) - (s?.updated||0);
    return s && (
        <>
            {s?.created && `${s.created} created ` || ''}
            {s?.updated && `${s.updated} updated ` || ''}
            {s?.deleted && `${s.deleted} deleted ` || ''}
            {s?.enabled && `${s.enabled} enabled ` || ''}
            {s?.disabled && `${s.disabled} disabled ` || ''}
            {indeterminate_saved && `${indeterminate_saved} saved` || ''}
            {s?.warnings && `${s.warnings} warnings ` || ''}
            {s?.errors && `${s.errors} errors ` || ''}
        </>
    ) || null;

}
